import { render, staticRenderFns } from "./CapabilityRatingsCpt.vue?vue&type=template&id=257a9183&scoped=true&"
import script from "./CapabilityRatingsCpt.vue?vue&type=script&lang=ts&"
export * from "./CapabilityRatingsCpt.vue?vue&type=script&lang=ts&"
import style0 from "./CapabilityRatingsCpt.vue?vue&type=style&index=0&id=257a9183&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "257a9183",
  null
  
)

export default component.exports